<template>
  <Transition>
    <div class="splash" v-if="showSplashScreen">
      <div class="splash__content">
        <LogoBanxa />
        <Loader />
      </div>
    </div>
  </Transition>
</template>
<script setup>
import { computed } from "vue";

import { useGlobalStore } from "@/stores/globalStore";
import LogoBanxa from "@/components/images/LogoBanxa.vue";
import Loader from "@/components/icons/Loader.vue";

const store = useGlobalStore();
const showSplashScreen = computed(
  () => !store.global.merchant || store.global.isShowSplash
);
</script>
<style lang="scss">
.splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--background);
  z-index: 20;
  display: grid;
  justify-items: center;
  align-items: center;

  &__content {
    display: flex;
  }
}

.splash__content .logo {
  max-width: 16rem;
  align-self: center;
  margin-right: 0.8rem;
}

.loader {
  height: 3rem;
  width: 3rem;
}
</style>
